import type * as core from '../../../../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.orgStructureSpace',
    'package:data.higherEd.payroll',
    'package:data.higherEd.research.idc.coreFunctions',
    'package:data.higherEd.research.idc.depreciationAndInterest',
    'package:data.higherEd.research.idc.gl',
    'package:data.higherEd.research.idc.libraries',
    'package:data.higherEd.research.idc.spaceSurvey',
    'resource:data.dimensions.idcFunctionSpace.entities.entry.attributes.idcFunction',
    'resource:data.dimensions.idcFunctionSpace.entities.entry.attributes.space',
    'resource:data.dimensions.idcFunctionSpace.entities.entry.attributes.weight',
    'resource:data.dimensions.idcFunctionSpace.entities.entry',
    'resource:data.dimensions.idcFunctionSpace',
    'resource:data.dimensions.jobTitles.entities.jobTitle.attributes.daCategory',
    'resource:data.dimensions.jobTitles.entities.jobTitle.attributes.libraryUserCategory',
    'resource:data.dimensions.organization.entities.department.attributes.isAcademic',
    'resource:data.enums.daCategory',
    'resource:data.enums.daCategory.entries.businessOfficer',
    'resource:data.enums.daCategory.entries.faculty',
    'resource:data.enums.daCategory.entries.generalSupport',
    'resource:data.enums.daCategory.entries.student',
  ],
  description:
    'Contains various data models and records that pertain to indirect cost recovery',
  name: 'IDC Data - Complete (Basic)',
} as const satisfies core.quiver.Package
